import type { FeatureKey } from '../types/content';

export const siteConfig = {
  name: 'Qorvessa Executive Partners',
  /** Gold "Q" monogram on black. Rendered with a screen blend so the black disappears on dark surfaces. */
  logoUrl: 'https://cdn.magicpatterns.com/uploads/aUySTuKL5XUjdoc14yiMmy/25eef8fd-3a9b-4e8a-8a05-753dfede3067.jpg',
  /**
   * Feature switches. Set `consultants` to false to hide the team section
   * everywhere; legacy team URLs then redirect to the Contact page.
   */
  features: {
    consultants: true,
  } as Record<FeatureKey, boolean>,
  /**
   * Endpoint that receives inquiry form submissions as a JSON POST and returns
   * a 2xx status on success (e.g. a Formspree/Basin form URL or your own API).
   * Leave empty until a submission service is connected.
   */
  inquiryEndpoint: '',
};
